import type { PillProps } from '@/shared/components';
import type { StripeConnectionStatus } from '@/shared/api';

type StatusPresentation = {
  label: string;
  variant: NonNullable<PillProps['variant']>;
};

const statusPresentation: Record<StripeConnectionStatus, StatusPresentation> = {
  Unconfigured: { label: 'Nicht eingerichtet', variant: 'outline' },
  Untested: { label: 'Prüfung offen', variant: 'warning' },
  Connected: { label: 'Verbunden', variant: 'live' },
  Failed: { label: 'Prüfung fehlgeschlagen', variant: 'stop' },
};

const doctorMessages: Record<string, string> = {
  connected: 'Stripe-Konto ist bereit für Zahlungen.',
  connected_sandbox: 'Stripe-Sandbox ist für Testzahlungen bereit.',
  charges_disabled: 'Stripe erlaubt für dieses Konto noch keine Zahlungen.',
  currency_mismatch:
    'Die Stripe-Kontowährung passt nicht zur Währung des Workspace. Die Workspace-Währung stellen Sie unter Einstellungen → Workspace ein.',
  workspace_currency_changed:
    'Die Währung des Workspace wurde geändert. Prüfen Sie die Verbindung erneut; bis dahin sind Zahlungen ausgesetzt.',
  credentials_invalid: 'Die Stripe-Zugangsdaten wurden abgelehnt.',
  stripe_request_failed: 'Stripe konnte gerade nicht geprüft werden.',
  keys_swapped:
    'Im Feld „Publishable Key" steht ein geheimer Schlüssel. Publishable Key beginnt mit pk_, Secret Key mit sk_ — die beiden sind vertauscht.',
  publishable_key_invalid: 'Der Publishable Key ist keiner: er muss mit pk_ beginnen.',
  webhook_secret_invalid: 'Das Webhook Signing Secret ist keines: es muss mit whsec_ beginnen.',
  key_mode_mismatch:
    'Secret Key und Publishable Key gehören zu verschiedenen Stripe-Modi (Test bzw. Live). Zahlungen würden erst beim Bezahlen scheitern.',
};

export function getStatusPresentation(status: StripeConnectionStatus): StatusPresentation {
  return statusPresentation[status];
}

export function getDoctorMessage(reason: string): string {
  return doctorMessages[reason] ?? reason;
}
